import {type RunSelectorAnalyticsLocation} from '../../components/RunSelector/RunSelectorAnalyticsLocationContext';
import {makeTrackEvent} from './makeTrackEvent';

export type VisibilityMenuAction =
  | 'Visibility menu opened'
  | 'Make all visible'
  | 'Make all hidden'
  | 'Only show visualized toggled'
  | 'Select visible runs';

export type VisibilityMenuEvent = {
  action: VisibilityMenuAction;
  method: 'hotkey' | 'dropdown' | 'filter_modal';
  location?: RunSelectorAnalyticsLocation;
};

export const trackRunVisibilityMenu = makeTrackEvent<
  VisibilityMenuEvent,
  {
    action: {
      description: 'the menu option that was selected';
    };
    location: {
      description: 'where the action was triggered from';
    };
    method: {
      description: 'the method used to trigger the action';
    };
    _description: 'Tracks visibility menu interactions in run selector';
    _location: 'report, runs-table, workspace, create-sweep-prior-runs, sweep-prior-runs';
    _motivation: 'track usage';
  }
>('Run selector visibility menu');
